<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class GenericWhitelistService extends Vue {
  // purpose: get all the configTypes in the table regardless of version
  static getAllConfigs() {
    const response = axios.get('/api/genericwhitelist/config').then(data => data.data);
    return response;
  }

  // purpose = get all configTypes for a version
  static getAllConfigTypesForVersion(version) {
    const response = axios.get(`/api/genericwhitelist/config/${version}`).then(data => data.data);
    return response;
  }

  static postGenericWhitelistConfig(payload) {
    const payloadMap = {};
    const keys = Object.keys(payload);
    const values = Object.values(payload);
    for (let i = 0; i < keys.length; i++) {
      payloadMap[keys[i]] = values[i];
    }
    console.log('Submitting info');
    axios.put('/api/genericwhitelist/config/', payloadMap);
  }

  static separateVersionFiidsToRows(versionFiids) {
    const versionFiidsByRow = [];
    const i = 0;
    const emptyVersionFiidsByRowObject = {
      configType: '',
      version: '',
      fiid: '',
    };
    let rowObject = emptyVersionFiidsByRowObject;

    Object.keys(versionFiids).forEach((item) => {
      Object.keys(versionFiids[item].fiIds).forEach((idx) => {
        rowObject.configType = versionFiids[item].configType;
        rowObject.fiid = versionFiids[item].fiIds[idx];
        rowObject.version = 'v1';
        versionFiidsByRow.push(JSON.parse(JSON.stringify(rowObject)));
        rowObject = emptyVersionFiidsByRowObject;
      });
    });
    return versionFiidsByRow;
  }

  static getConfigTypesList(genericWhitelistObjectsList) {
    const configTypesList = [];

    Object.keys(genericWhitelistObjectsList).forEach((idx) => {
      configTypesList.push(genericWhitelistObjectsList[idx].configType);
    });
    return configTypesList;
  }
}
</script>
